import React, { Component } from 'react'
import classNames from './OrchestraPreferences.css'

export default class OrchestraPreferences extends Component {

  parsePref = (key, rawVal) => {
    const valType = this.props.items[key].type;
    switch(valType) {
      case 'int': {
        return parseInt(rawVal);
      }
      case 'float': {
        return parseFloat(rawVal);
      }
      case 'bool': {
        return (rawVal === 'true');
      }
      default: {
        return rawVal;
      }
    }
  }
  onPrefChange = (e) => {
    const { items } = this.props;
    const prefKey = e.target.getAttribute('name');
    const parsedVal = this.parsePref(prefKey, e.target.value);

    // guard against invalid values
    if (parsedVal == null) return;
    if (parsedVal == undefined) return;
    if (isNaN(parsedVal)) return;

    // overwrite existing value with new one
    items[prefKey].value = parsedVal;

    // send update to server
    this.props.onPrefChange(items);
  }

  onPrefInc = (e) => {
    const { items } = this.props;
    const prefKey = e.target.getAttribute('name');
    let item = items[prefKey];
    item.value = item.value + item.granularity;

    // send update to server
    this.props.onPrefChange(items);
  }

  onPrefDec = (e) => {
    const { items } = this.props;
    const prefKey = e.target.getAttribute('name');
    let item = items[prefKey];
    item.value = item.value - item.granularity;

    // send update to server
    this.props.onPrefChange(items);
  }

  renderItems = () => {
    if (!this.props.items) return [];
    const items = [];
    for (let [key, value] of Object.entries(this.props.items)) {
      items.push(this.renderItem(key, value));
    }
    return items;
  }
  renderItem = (pref_key, data) => {
    const { control_type } = data;

    // generate some help / tooltip for known preferences
    let helpTextForKey = {
      // floating
      'layer_count': 'Number of overlapping vertical layers',
      'base_speed': 'Movement speed of images',
      'spawn_x': 'X coordinate of the spawn point',
      'spawn_y': 'Y coordinate of the spawn point',
      'spawn_angle': 'The direction or angle images will travel from the spawn point',
      'spawn_breadth': 'If the images flow in a stream from the spawn point, this is the width of that stream (positions chosen at random)',
      'spawn_interval': 'The length of time in seconds before new images are spawned',
      // ken burns
      'travel': 'Distance the images will drift from center as they animate',
      'dwell_time': 'The amount of time an image will persist before beginning to fade out (in seconds)',
      'transition_time': 'The amount of time taken for the image to fade away (in seconds)',
      'end_scale': 'The final scale of the image as it animates expressed as a coefficient - 1.0 means no scaling at all, 2.0 means the image will grow to twice the size',
    }
    var helpText = helpTextForKey[pref_key] || '';

    switch(control_type) {
      case 'slider': {
        return (
          <li key={pref_key}>
            <Slider
              name={pref_key}
              value={data.value}
              prefix={data.nice_name}
              min={data.min}
              max={data.max}
              step={data.granularity}
              onChange={this.onPrefChange}
              onInc={this.onPrefInc}
              onDec={this.onPrefDec}
            />
            <div className={classNames.prefHelpText}>{helpText}</div>
          </li>

        );
      }
      case 'field': {
        return (
          <li key={pref_key}>
            <span>{data.nice_name}: </span>
            <input
              name={pref_key}
              type='number'
              value={data.value}
              min={data.bounded ? data.min : ''}
              max={data.bounded ? data.max : ''}
              className={classNames.numberInput}
              onChange={this.onPrefChange}
            />
            <div className={classNames.prefHelpText}>{helpText}</div>
          </li>
        );
      }
      case 'select': {
        return
      }
    }
  }
  render () {
    return (
        <ul className={classNames.prefList}>
            {this.renderItems()}
        </ul>
    )
  }
}

const Slider = ({ name, value, onChange, onInc, onDec, min, max, step=1, prefix='', rangeInputType = 'range' }) => (
    <div>
      <span className={classNames.optionValue}>
        {prefix}: {value}
      </span>
      <div>
      <input className={classNames.sliderButton} name={name} type={"button"} value={"-"} onClick={onDec}></input>
      <input
        value={value}
        onChange={onChange}
        type={rangeInputType}
        min={min}
        max={max}
        step={step}
        className={classNames.slider}
        name={name}
      />
      <input className={classNames.sliderButton} name={name} type={"button"} value={"+"} onClick={onInc}></input>
      </div>
    </div>
  )



// WEBPACK FOOTER //
// ./src/components/orchestra/OrchestraPreferences.js